<div
  class="folder-menu-item"
  *ngFor="let folder of folders"
  [class.simple]="simpleMode"
  (click)="selectFolder($any(folder), $event)"
>
  <div class="folder-icon-container">
    <app-svg src="/assets/icons/folder.svg"></app-svg>
  </div>
  <span>
    <span [appTooltip]="folder.title">{{ folder.title }}</span>
    <div class="meta" *ngIf="!simpleMode">
      Folder ⋅ {{ folderGalleryCount[folder.id] }} <span *ngIf="folderGalleryCount[folder.id] !== 1">Galleries</span
      ><span *ngIf="folderGalleryCount[folder.id] === 1">Gallery</span>
    </div>
  </span>
  <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
</div>

<div class="tree-item" *ngFor="let item of galleryTree" [class.disabled]="item.disabled" [class.simple]="simpleMode">
  <div
    class="gallery main-gallery"
    [class.active]="item.gallery.id === currentGallery?.id"
    (click)="selectGallery(item.gallery, $event)"
    [id]="item.gallery.id"
  >
    <img
      [src]="item.gallery | galleryTeaserUrl : 56"
      alt=""
      *ngIf="item.gallery.teaser.uuid"
      class="gallery-teaser-asset"
    />
    <div class="gallery-teaser-asset" *ngIf="!item.gallery.teaser.uuid"></div>
    <span>
      <span [appTooltip]="item.gallery.name || item.gallery.title">{{
        item.gallery.name || item.gallery.title || 'Untitled'
      }}</span>
      <div class="meta" *ngIf="!simpleMode">
        Gallery ⋅ {{ item.gallery.total_assets_count }} Asset<span *ngIf="item.gallery.total_assets_count !== 1"
          >s</span
        >
      </div>
    </span>
    <ng-container *ngIf="cta">
      <button
        appButton
        name="finder-cta"
        location="finder-content"
        color="primary"
        size="1"
        spacing="3"
        height="0-5"
        shape="round"
        [class.loading]="loading === item.gallery.id"
      >
        <span [class.hidden-text]="loading === item.gallery.id">{{ cta }}</span>
        <app-loading-indicator
          *ngIf="loading === item.gallery.id"
          color="white"
          size="smaller"
          class="button-loading-indicator"
        >
        </app-loading-indicator>
      </button>
    </ng-container>
    <ng-container *ngIf="!cta">
      <app-svg src="/assets/icons/check-filled.svg" *ngIf="item.gallery.id === currentGallery?.id"></app-svg>
      <app-svg
        src="/assets/icons/check-empty.svg"
        *ngIf="item.gallery.id !== currentGallery?.id && !blockGallerySelection"
      ></app-svg>
    </ng-container>
  </div>
  <div class="sub-galleries">
    <div
      class="gallery sub-gallery"
      *ngFor="let subGallery of item.children"
      [id]="subGallery.id"
      [class.active]="subGallery.id === currentGallery?.id"
      (click)="selectGallery(subGallery, $event)"
    >
      <div class="sub-gallery-line"></div>
      <img
        [src]="subGallery | galleryTeaserUrl : 56"
        alt=""
        *ngIf="subGallery.teaser.uuid"
        class="gallery-teaser-asset"
      />
      <div class="gallery-teaser-asset" *ngIf="!subGallery.teaser.uuid"></div>
      <span>
        <span [appTooltip]="subGallery.name || subGallery.title">{{
          subGallery.name || subGallery.title || 'Untitled'
        }}</span>
        <div class="meta" *ngIf="!simpleMode">
          Sub-Gallery ⋅ {{ subGallery.total_assets_count }} Asset<span *ngIf="subGallery.total_assets_count !== 1"
            >s</span
          >
        </div>
      </span>
      <ng-container *ngIf="cta">
        <button
          appButton
          name="finder-cta"
          location="finder-content"
          color="primary"
          size="1"
          spacing="3"
          height="0-5"
          shape="round"
          [class.loading]="loading === subGallery.id"
        >
          <span [class.hidden-text]="loading === subGallery.id">{{ cta }}</span>
          <app-loading-indicator
            *ngIf="loading === subGallery.id"
            color="white"
            size="smaller"
            class="button-loading-indicator"
          >
          </app-loading-indicator>
        </button>
      </ng-container>
      <ng-container *ngIf="!cta">
        <app-svg src="/assets/icons/check-filled.svg" *ngIf="subGallery.id === currentGallery?.id"></app-svg>
        <app-svg
          src="/assets/icons/check-empty.svg"
          *ngIf="subGallery.id !== currentGallery?.id && !blockGallerySelection"
        ></app-svg>
      </ng-container>
    </div>
  </div>
</div>
